import tw, { styled } from "twin.macro";

export const HeroContainer = styled.header`
  ${tw`
  
`}
  height: 540px;
  background-size: cover !important;
  text-align: initial;
  margin-top: 0;
  object-fit: contain;

  ${(props) =>
    `background: url('https://image.tmdb.org/t/p/original${props?.background}');`}

  .heroContent {
    padding-left: 2rem;
    padding-right: 2rem;
    padding-top: 222px;
    height: 200px;
  }

  .fadeBottom {
    height: 7.4rem;
    background-image: linear-gradient(
      180deg,
      transparent,
      rgba(37, 37, 37, 0.61),
      #111
    );
  }
`;

export const HeroTitle = styled.h1`
  ${tw`
    text-5xl
    font-extrabold
    mb-4
  `}
`;

export const HeroDescription = styled.p`
  ${tw`
    font-medium
    text-lg
    mb-4
  `}
  width: 45rem;
  max-width: 80vw;
  line-height: 1.3;
`;

export const HeroButton = styled.button`
  ${tw`
    cursor-pointer
    font-bold
    rounded
    px-8
    py-2
    mr-2
  `}

  background-color: rgba(51, 51, 51, 0.5);
  color: white;
  border: 0;

  &:hover {
    background-color: #e6e6e6;
    color: black;
    transition: all 0.2s;
  }
`;
